import {Component} from '@angular/core';
import {RouterModule} from '@angular/router';
import {WaButtonDirective} from 'angular-awesome';
import {WaTextDirective} from 'angular-awesome';
import {WaDetailsDirective} from 'angular-awesome';
import {MarkdownComponent} from 'ngx-markdown';
@Component({
	selector:'jwebmp-comp-wa-cluster',
	templateUrl:'./WaClusterPage.html',
	styles: [],
	styleUrls:['./WaClusterPage.scss'
],
	viewProviders:[],
	animations:[],
	providers:[],
	schemas:[],
	preserveWhitespaces:true,
	host:{},
	imports:[
		RouterModule,
		WaButtonDirective,
		WaTextDirective,
		WaDetailsDirective,
		MarkdownComponent,
],
	standalone:true
})
export class WaClusterPage
{
	mdContent_311 = `\`\`\`java
import com.jwebmp.webawesome.components.WaCluster;
\`\`\``;
	mdContent_312 = `\`\`\`java
var cluster = new WaCluster<>();
cluster.setGap(PageSize.Small);
cluster.add(new WaTag<>("Java"));
cluster.add(new WaTag<>("Angular"));
\`\`\``;
}
